import { proofStrip } from '../../../content/agencyCopy';
import RevealOnScroll from '../RevealOnScroll';

export default function ProofStrip() {
  return (
    <section
      className="px-6 py-16"
      style={{ background: 'var(--fa-paper)', borderTop: '1px solid var(--fa-rule)' }}
    >
      <RevealOnScroll className="max-w-[1120px] mx-auto">
        <div className="fa-label mb-6 flex items-center gap-3">
          <span className="fa-status-dot fa-status-dot--live" aria-hidden="true" />
          {proofStrip.label}
        </div>
        <ul className="flex flex-col md:flex-row md:items-start gap-x-10 gap-y-3 text-[15px]">
          {proofStrip.items.map((item, i) => (
            <li key={i} className="flex items-start gap-3">
              <span
                className="fa-mono text-[13px] mt-1"
                style={{ color: 'var(--fa-muted)' }}
              >
                0{i + 1}
              </span>
              <span className="fa-glow-text">{item}</span>
            </li>
          ))}
        </ul>
      </RevealOnScroll>
    </section>
  );
}
